import { currentTimeStamp } from 'utils/GetDataUtil';

export const convertPhoenixToXDEObject = (inputData, outputRange, displayData, dimensions, metrics, selectedServiceData, uniqueId) => {
  
    const dataSetObj = {
        dataSetOrder: 1,
        datasetRange: `${outputRange.cellRange}!${outputRange.sheetName}`,
        displaySetting: getDisplaySetting(displayData),
        reportId: uniqueId,
        reportName: getDisplayDetailsObject(displayData)?.value || 'Dataset',
        reportType: 'Phoenix',
        lastRefreshTime: currentTimeStamp(),
        orientation: 'Horizontal',
        dimensions: dimensions,
        metrics: metrics,
        inputNodes: {
            inputCellNo: inputData.cellNumber,
            inputCellValueRemove: getEndRange(inputData),
            inputSheetName: displayData.sheetName,
            mandatoryFields: [{
					colId: "ReferenceDate",
					colText: "As Of Date",
					defaultValue: inputData?.referancedate?.text,
					groupId: "ReferenceDate",
					showCTP: false,
					smartDateKey: "last_month",
					value: inputData?.referancedate?.text,
			    }],
            nonMandatoryFields: [],
            inputData : {
                ...inputData,
                outputEndRange:{sheetName: outputRange.sheetName, cellRange: outputRange.cellRange}
            }
        },
        outputNodes: {
            endOutputCellValue: outputRange.cellRange.split(':')[1],
            outputCellNo: outputRange.cellRange.split(':')[0],
            outputSheetName: displayData.sheetName,
            nonMandatoryFields: [],
        },
        service: {
            // serviceObject method we can use as it is
            endpoint: '/phx/v3/metrics',
            help: '',
            id: '',
            level: '0',
            serviceMethod: 'POST',
        },
        serviceData: selectedServiceData,
    };

    return dataSetObj;
};

const getEndRange = (data) => {
    return data.inputEndRange.cellRange.split(':')[1];
}

const getDisplayDetailsObject = (displayData) => {
    const displayDetails = displayData.displaySetting.filter(d => d.id === 'dataset-title');
    return displayDetails.length > 0 ? displayDetails[0] : null;
};

const getDisplaySetting = (displayData) => {
    return {
        ...displayData,
        displaySetting: displayData.displaySetting.map(detail => {
            if (detail.id === 'time-stamp') {
                return {
                    ...detail,
                    value: currentTimeStamp()
                };
            }
            return detail;
        })
    };
};

export const newDatasetObject = (uniqueId, report) => {
    return {
        "nextReportIndex": "1",
        "hiddenWorksheetID": uniqueId,
        "id": uniqueId,
        "sheetID": uniqueId,
        "workbookName": "Phoenix",
        reports: [report]
    }
}
